

const getters = {
    getCount: (state) => {
        return state._counter;
    },
    getLuStates: (state) => {
        return state._luStateAppResourceCollection;
    },
    getLuStateIds: (state) => {
        let ret = null;
        ret = state._luStateAppResourceCollection?.appResourceCollection?.toArray().map(f=>f.id);
        return ret;
    },
    getLuStatesAsArray: (state) => {
        let ret = null;
        ret = state._luStateAppResourceCollection?.appResourceCollection?.toArray();
        return ret;
    },
};

export default getters;
